(() => {
  if (window.senderCartUpsellBound) return;
  window.senderCartUpsellBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sender-upsell-add]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const drawer = document.querySelector('cart-drawer');
    const variantId = Number(button.dataset.variantId);
    const errorNode = button.closest('[data-sender-cart-upsell]')?.querySelector('[data-sender-upsell-error]');
    if (!drawer || !variantId) return;

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }

    try {
      const sections = drawer.getSectionsToRender().map((section) => section.id);
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const cartData = await response.json();
      if (!response.ok || cartData.status) {
        throw new Error(cartData.description || cartData.message || 'Das Produkt konnte nicht hinzugefügt werden.');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'sender-cart-upsell',
          productVariantId: String(variantId),
          cartData,
        });
      }
      drawer.renderContents(cartData);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
      if (errorNode) {
        errorNode.textContent = error.message;
        errorNode.hidden = false;
      }
    }
  });
})();
